module.exports = __webpack_public_path__ + "media/images/icon/leaderboard-black-85a7a3113893c2540bfc9cbb35ad3bb1.svg";